import React from 'react';
import { Path } from 'react-konva';

const ANCHOR_COLOR = '#3B82F6';
const ANCHOR_HOVER_COLOR = '#60A5FA';

const ResizeAnchor = ({
  x = 0,
  y = 0,
  size,
  stageScale = 1,
  color = ANCHOR_COLOR,
  hoverColor = ANCHOR_HOVER_COLOR,
  cursor = 'move',
  hoverCursor = 'move',
  draggable = true,
  onDragMove,
  onDragStart,
  onDragEnd,
}) => {
  const radius = size ?? Math.max(4, 6 / stageScale);
  const strokeW = Math.max(1, 2 / stageScale);

  const data = `M ${-radius},0 A ${radius},${radius} 0 1,0 ${radius},0 A ${radius},${radius} 0 1,0 ${-radius},0`;

  return (
    <Path
      x={x}
      y={y}
      data={data}
      fill={color}
      stroke={color}
      strokeWidth={strokeW}
      draggable={draggable}
      onDragMove={onDragMove}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onMouseEnter={(e) => {
        e.target.fill(hoverColor);
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = hoverCursor;
      }}
      onMouseLeave={(e) => {
        e.target.fill(color);
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = cursor;
      }}
    />
  );
};

export default ResizeAnchor;
